export const funeralPlan = (state = {}, action) => {
  switch (action.type) {
    case 'SET_FUNERAL_PLAN':
      return action.payload
    default:
      return state
  }
}
